import { render, staticRenderFns } from "./SortableFirmwideEmissionByCorp.vue?vue&type=template&id=b282b8c6"
import script from "./SortableFirmwideEmissionByCorp.vue?vue&type=script&lang=js"
export * from "./SortableFirmwideEmissionByCorp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports